module.exports = __webpack_public_path__ + "img/endMarker.c36a838d.png";